<template>
  <section class="section">

    <p class="has-text-weight-bold upload-help">👉 Upload an epub file and you'll receive the first section of text by email.</p>

    <b-message type="is-info" has-icon v-if="!isAuthenticated">
      <div>Authentication needed in order to upload an epub file</div>
      <a href="/#/signup">Create an account</a> or <a href="/#/signin">sign in</a>
    </b-message>

    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <error-message/>
          <b-message type="is-warning" has-icon v-if="isAuthenticated && !canUploadEbook">
            You need to subscribe to upload a ebook.
          </b-message>
          <p class="section" v-if="isAuthenticated && !canUploadEbook">
            <button class="button is-secondary is-large" @click="goToSubscription">Subscribe</button>
          </p>
          <b-field>
            <b-upload v-model="dropFile"
              accept=".epub"
              drag-drop
              type="is-secondary"
              :disabled="!canUploadEbook">
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                      <b-icon
                          icon="upload"
                          size="is-large">
                      </b-icon>
                  </p>
                  <p>Drop your epub file here or click to upload</p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <div class="tags">
            <span class="tag is-primary" v-if="dropFile">
              {{ dropFile.name }}
              <button class="delete is-small" type="button" @click="deleteDropFile()"/>
            </span>
          </div>
          <button type="button" v-bind:class="{ 'is-loading': isLocalLoading }" class="button is-secondary" @click="uploadEbook" :disabled="!canUploadEbook">
              <span>Start reading!</span>
          </button>
          <p class="section" v-if="!isSubscribedUser">
            {{ canRreadEbooksSentence }}
          </p>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
import errorMessage from '@/components/error-message'

export default {
  name: 'uploadEbook',
  data () {
    return {
      dropFile: null
    }
  },
  methods: {
    deleteDropFile () {
      this.dropFile = null
    },
    goToSubscription () {
      this.$router.push('/subscription')
    },
    uploadEbook () {
      this.$store.dispatch('uploadEbook', { file: this.dropFile })
      this.dropFile = null
    }
  },
  computed: {
    canRreadEbooksSentence () {
      if (!this.isSubscribedUser) {
        if (this.$store.getters.getUserTicketsCount > 0) {
          return `You can still read ${this.$store.getters.getUserTicketsCount} ebooks.`
        }
        return `You can't start a new ebook.`
      }
    },
    canUploadEbook () {
      return this.$store.getters.getUserTicketsCount > 0 || this.isSubscribedUser
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'uploadEbook' && localLoading.active
    },
    isSubscribedUser () {
      return this.$store.getters.isSubscribedUser
    }
  },
  components: {
    errorMessage
  }
}
</script>

<style scoped>
  .upload-help {
    margin-bottom: 1rem;
  }

</style>
